export function encodeQueryStringParams(params: Record<string, string>) {
  return Object.keys(params)
    .map((param) => `${param}=${encodeURIComponent(params[param])}`)
    .join("&");
}

/** Uses JSON.stringify and JSON.parse to deep copy an object. The object must be safely serializable via JSON.stringify. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deepCopyJson(value: any): any | undefined {
  if (value === undefined) {
    return undefined;
  }

  return JSON.parse(JSON.stringify(value));
}
